<template>
  <section class="d-inline-flex">
    <dp-select v-if="showCollectionsDropdown" :options="groupOptions" class="product-collections-dropdown w-100" @input="scrollToHash" />
    <b-input-group id="group-search" class="mb-n4" size="md">
      <label for="search-by-name" class="sr-only">Search Tag by name</label>
      <b-form-input id="search-by-name" v-model="field" class="p-2 p-sm-3 p-md-4" type="search" placeholder="Search" />
      <b-input-group-append>
        <span class="input-group-text"><fa-icon :icon="['fas', 'search']" size="sm" /></span>
      </b-input-group-append>
    </b-input-group>
  </section>
</template>

<script>
import DpSelect from './library/Select';
export default {
  name: 'Search',
  components: { DpSelect },
  props: {
    groups: {
      type: Array,
      required: true,
    },
    showCollectionsDropdown: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      value: '',
    };
  },
  computed: {
    field: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    groupOptions() {
      const options = [{ value: '', text: 'Select Category' }];
      this.groups?.forEach((group) => options.push({ value: this.getGroupHash(group), text: group.name }));
      return options;
    },
  },
  methods: {
    scrollToHash(hash) {
      this.$emit('scrollToHash', hash);
    },
    getGroupHash(group) {
      return encodeURIComponent(group.name.replace(/\s+/g, '-').toLowerCase());
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
#group-search {
  width: 25%;
  position: absolute;
  left: calc(100% - 25%);
  -webkit-transition: all 0.5s ease 0s;
  -moz-transition: all 0.5s ease 0s;
  -o-transition: all 0.5s ease 0s;
  transition: all 0.5s ease 0s;
  border: none;
  &:focus-within {
    width: 50%;
    left: calc(100% - 50%);
    .input-group-append {
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      background-clip: padding-box;
      border-right: none;
      border-left: none;
      border-radius: 0 0.25rem 0.25rem 0;
      span {
        color: $dp-navy;
      }
    }
  }
  .input-group-append {
    span {
      color: $dp-gray-4;
      background-color: $dp-white !important;
    }
  }
  input {
    border-right: none;
    line-height: normal;
    &:focus {
      box-shadow: none;
    }
  }
  @media (max-width: 756px) {
    position: unset !important;
    width: 50%;
    left: calc(100% - 52%) !important;
    padding-bottom: 3rem;
    margin-left: auto;
    margin-right: 0.5rem;
    &:focus-within {
      width: 55%;
      left: calc(100% - 57% - 2rem) !important;
      @media (max-width: 320px) {
        width: 65%;
        left: calc(100% - 67% - 2rem) !important;
      }
      @media (min-width: 320px) and (max-width: 576px) {
        width: 75%;
        left: calc(100% - 77% - 2rem) !important;
      }
    }
  }
}
.product-collections-dropdown {
  width: 50%;
  max-width: 180px;
  margin-left: 0.5rem;
  @media (max-width: 320px) {
    width: 60%;
    max-width: 200px;
  }
  @media (min-width: 320px) and (max-width: 576px) {
    width: 45%;
    margin-right: 0.5rem;
  }
  @media (min-width: 576px) and (max-width: 991px) {
    max-width: 30%;
  }
  @media (min-width: 991px) {
    max-width: 40%;
    margin-left: 0;
  }
}
</style>

<style lang="scss">
.product-collections-dropdown .dropdown .dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: 320px) {
    max-height: 200px;
  }
  @media (min-width: 320px) and (max-width: 576px) {
    max-height: 200px;
  }
  @media (min-width: 576px) and (max-width: 991px) {
    max-height: 300px;
  }
  transition: all 0.5s ease 0s;
}
</style>
